export const BACKGROUND_COLOR = '#e9edec'
export const DARK_BACKGROUND_COLOR = '#0F1511'
export const GRID_LINE_COLOR = '#d9dfdb'
export const DARK_GRID_LINE_COLOR = '#262C28'
export const COLORS = ['#5FED83', '#C898FD', '#DA7210', '#8DD6FF', '#0FBF3E', '#5FB9FF', '#08872B'] as const
